import { Pipe, type PipeTransform } from "@angular/core";

@Pipe({
	name: "ellipsis",
	standalone: true,
})
export class EllipsisPipe implements PipeTransform {
	transform(word: string | null, maxLength = 12): string {
		if (!word) {
			return "";
		}

		if (word.length <= maxLength) {
			return word;
		}

		return word.slice(0, maxLength) + "...";
	}
}
